export default "__VITE_ASSET__iU4T_Yz6__"